import { combineReducers } from "redux";
import app, { AppState } from "./appSlice";
import version, { VersionState } from "./versionSlice";
import search, { SearchState } from "./searchSlice";
import scale, { ScaleState } from "./scaleSlice";
import lighthouse, { LighthouseState } from "./lighthouseSlice";
import triggers, { TriggersState } from "./triggersSlice";
import overett, { OverettState } from "./overettSlice";

const rootReducer = combineReducers({
    app,
    version,
    search,
    scale,
    lighthouse,
    triggers,
    overett,
});

export type StoreState = {
    app: AppState;
    version: VersionState;
    search: SearchState;
    scale: ScaleState;
    lighthouse: LighthouseState;
    triggers: TriggersState;
    overett: OverettState;
};

export default rootReducer;
